import { TableRow } from "@mui/material";
import styled from "styled-components";
import { color } from "../../../../shared/styles";

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:hover": {
        backgroundColor: color.status.INFO_LIGHT,
        cursor: "pointer",
    },
    transition: "background-color 0.3s ease, color 0.3s ease",
}));

export const SelectionActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
`;

export const ProviderTableLayout = styled.div<{ $withRadio: boolean }>`
    min-width: 0;

    table {
        table-layout: ${({ $withRadio }) => ($withRadio ? "fixed" : "auto")};
        ${({ $withRadio }) => $withRadio && "min-width: 1050px;"}
    }

    ${({ $withRadio }) => $withRadio && `
        th:first-child,
        td:first-child {
            width: 44px;
            min-width: 44px;
            max-width: 44px;
        }
    `}
`;

export const ContentWrapper = styled.div`
    padding: 32px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 40px;
    border-radius: 20px;
    background-color: ${color.emphasis.NEUTRAL_N0};
    flex: 1;
    overflow: hidden;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
    height: 100%;
`;

export const ExpandableContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 40px;
`;
